
import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Typography,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemText,
    Paper,
    CircularProgress,
    Chip,
    Avatar, Button,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../Config';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BookingDetails = () => {
    const { bookingId } = useParams();
    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate()
    const printRef = useRef();
    const handlePrint = () => {
        const printContents = printRef.current.innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload(); // Reload to restore app state
    };

    useEffect(() => {
        const fetchBooking = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${apiUrl}/bookings/getbooking/${bookingId}`);
                setBooking(response.data.booking);
                console.log(response.data.booking, 'book');
            } catch (err) {
                console.error(err);
                setError('Failed to fetch booking details.');
            } finally {
                setLoading(false);
            }
        };

        fetchBooking();
    }, [bookingId]);

    console.log(booking, "bookings")
    if (loading) return <Box p={4}><CircularProgress /></Box>;
    if (error) return <Typography color="error">{error}</Typography>;
    if (!booking) return <Typography>No booking data found</Typography>;

    const { user, userAddress: address, booking_items: items } = booking;

    return (
        <Box p={{ xs: 2, md: 4 }} bgcolor="#f9f9f9">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Button
                    variant="text"
                    color="inherit" // use 'inherit' instead of 'default' for MUI v5+
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(-1)}
                >
                    Back
                </Button>
                <Typography variant="h4" fontWeight={400} >
                    Booking Details - #{booking.id}
                </Typography>
            </Box>

            <Grid container spacing={4} mb={5}>
                {/* User Info */}
                <Grid item size={{ xs: 12, md: 6 }}>


                    <div >
                        <Paper elevation={3} sx={{ p: 3 }}>
                            <Box display="flex" alignItems="center" mb={2}>
                                <PersonIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6" fontWeight={600}>
                                    User Information
                                </Typography>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <Box ref={printRef}>


                                <Typography><strong>Name:</strong> {user?.name}</Typography>
                                <Typography><strong>Email:</strong> {user?.email}</Typography>
                                <Typography><strong>Phone:</strong> {user?.phoneNumber}</Typography>

                                {address && (
                                    <Typography sx={{ mt: 1 }}>
                                        <strong>Address:</strong><br />
                                        {address.parentName}, <br />
                                        {address.houseNo}, {address.street}, {address.landmark}, {address.villageOrTown}, {address.city}<br />
                                        {address.mandal} {address.district}, {address.state} {address.country} {address.pincode}
                                    </Typography>
                                )}
                            </Box>

                            <Box mt={3} textAlign="right">
                                <Button variant="contained" onClick={handlePrint}>
                                    Print
                                </Button>
                            </Box>
                        </Paper>
                    </div>

                </Grid>

                {/* Booking Info */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Box display="flex" alignItems="center" mb={2}>
                            <InfoIcon color="primary" sx={{ mr: 1 }} />
                            <Typography variant="h6" fontWeight={600}>Booking Information</Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <Typography>
                            <strong>Status:</strong>
                            <Chip
                                label={booking.bookingStatus}
                                color={booking.bookingStatus === 'Delivered' ? 'success' : 'warning'}
                                sx={{ ml: 1 }}
                            />
                        </Typography>
                        <Typography>
                            <strong>Payment:</strong>
                            <Chip
                                label={booking.isPaymentCompleted ? 'Completed' : 'Pending'}
                                color={booking.isPaymentCompleted ? 'success' : 'error'}
                                sx={{ ml: 1 }}
                            />
                        </Typography>
                        <Typography><strong>Total Amount:</strong> ₹{booking.totalAmount}</Typography>
                        <Typography><strong>Delivery Fee:</strong> ₹{booking.deliveryAmount}</Typography>
                        <Typography><strong>Booking Date:</strong> {new Date(booking.bookingDate).toLocaleString()}</Typography>
                        {booking.deliveryDate && (
                            <Typography><strong>Delivery Date:</strong> {new Date(booking.deliveryDate).toLocaleString()}</Typography>
                        )}
                    </Paper>
                </Grid>
            </Grid>

            {/* Ordered Items */}
            <Paper elevation={3} sx={{ p: 3 }}>
                <Box display="flex" alignItems="center" mb={2}>
                    <ShoppingCartIcon color="primary" sx={{ mr: 1 }} />
                    <Typography variant="h6" fontWeight={600}>Ordered Items</Typography>
                </Box>
                <Divider sx={{ mb: 3 }} />



                {items?.length > 0 ? (
                    <Grid container spacing={3}>
                        {items.map((item, index) => {
                            const isBook = !!item.book;
                            const isCombo = !!item.comboOffer;

                            const title = isBook
                                ? item.book?.title
                                : isCombo
                                    ? item.comboOffer?.title
                                    : 'N/A';

                            const imageUrl = isBook
                                ? item.book?.bookImages?.[0]?.imageUrl
                                : isCombo
                                    ? item.comboOffer?.imageUrl
                                    : null;

                            return (
                                <Grid item size={{xs:12,md:6,sm:6}} key={index}>
                                    <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                {imageUrl ? (
                                                    <Box
                                                        component="img"
                                                        src={imageUrl}
                                                        alt={title}
                                                        sx={{
                                                            width: 120,
                                                            height: 160,
                                                            objectFit: 'cover',
                                                            borderRadius: 2,
                                                            boxShadow: 1,
                                                        }}
                                                    />
                                                ) : (
                                                    <Avatar
                                                        variant="rounded"
                                                        sx={{ width: 120, height: 160, bgcolor: 'grey.300' }}
                                                    >
                                                        No Image
                                                    </Avatar>
                                                )}
                                            </Grid>

                                            <Grid item xs>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="subtitle1" fontWeight={600}>
                                                            {title}
                                                            {isBook && item.book?.author?.name && (
                                                                <> by {item.book.author.name}</>
                                                            )}
                                                        </Typography>
                                                    }
                                                    secondary={
                                                        <>
                                                            <Typography>
                                                                <strong>Quantity:</strong> {item.quantity}
                                                            </Typography>
                                                            <Typography>
                                                                <strong>Unit Price:</strong> ₹{item.unitPrice}
                                                            </Typography>
                                                           
                                            
                                                            {isCombo && (
                                                                <>
                                                                    <Typography>
                                                                        <strong>Items in Combo:</strong>{' '}
                                                                        {item.comboOffer?.books?.length || 0}
                                                                    </Typography>
                                                                    {item.comboOffer?.discountPercentage && (
                                                                        <Typography>
                                                                            <strong>Discount:</strong>{' '}
                                                                            {item.comboOffer.discountPercentage}%
                                                                        </Typography>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                </Grid>
                            );
                        })}
                    </Grid>
                ) : (
                    <Typography>No ordered items found.</Typography>
                )}



            </Paper>
        </Box>
    );
};

export default BookingDetails;
